module.exports = "/_next/static/images/7c7f11f74c09849a7afc4ce54064dea9-careers@3x.jpg";